import { environment } from '../../environments/environment';

export const AppConfig = {
  apiUrl: environment.apiUrl,
  version: '1.6.3',
  isTest: !environment.production && environment.isTest,
  defaultStorageMode: 'local',
  googleClientId: '426830911052-vdeq0q4b79kbgffqhfdgotq5mmqsg8mg.apps.googleusercontent.com',
  bugsnagApiKey: '09fa35baa35585b2c457bc4bedd0ad93',
};
